import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Divider from "@mui/material/Divider";
import SoftButton from "../../components/SoftButton";
import PropTypes from "prop-types";
import { useTranslation, Trans } from 'react-i18next';
import {useSoftUIController} from "../../context";
const EulaAgreementDialog = ({ open, handleAccept, handleDecline }) => {

    const [controller] = useSoftUIController();

    const {direction} = controller;

    const { t } = useTranslation(['eula', 'common']);
    const company = t('company.name', { ns: 'common' });
    const infoEmail = t('company.infoEmail', { ns: 'common' });



    return (
        <Dialog open={open} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                {t('eula.title')}
            </DialogTitle>
            <Divider />
            <DialogContent dividers={scroll === 'paper'} sx={{padding: "0px 24px", fontSize: "14px"}}>
                <p><b>{t('eula.lastUpdated')}</b> {t('eula.lastUpdatedDate')}</p>
                <br/>
                <p>
                    <Trans
                        ns="eula"
                        i18nKey="eula.preamble"
                        values={{ company }}
                        components={[<></>, <b key="company" />]}
                    />
                </p>
                <br/>
                <p>{t('eula.businessCustomers')}</p>
                <br/>
                <p>{t('eula.productsLicensed')}</p>
                <h3 style={{ marginTop: "15px", marginBottom: "8px" }}>{t('eula.section1.title')}</h3>
                <p>{t('eula.section1.body')}</p>

                <h4 style={{ marginTop: "9px", marginBottom: "5px" }}>{t('eula.section1_1.title')}</h4>
                <p>{t('eula.section1_1.body', { company })}</p>

                <h4 style={{ marginTop: "9px", marginBottom: "5px" }}>{t('eula.section1_2.title')}</h4>
                <p>{t('eula.section1_2.body')}</p>

                <h4 style={{ marginTop: "9px", marginBottom: "5px" }}>{t('eula.section1_3.title')}</h4>
                <p>{t('eula.section1_3.body')}</p>

                <h4 style={{ marginTop: "9px", marginBottom: "5px" }}>{t('eula.section1_4.title')}</h4>
                <p>{t('eula.section1_4.body')}</p>

                <h3 style={{ marginTop: "15px", marginBottom: "8px" }}>{t('eula.section2.title')}</h3>
                <h4 style={{ marginTop: "9px", marginBottom: "5px" }}>{t('eula.section2_1.title')}</h4>
                <p>{t('eula.section2_1.body', { company })}</p>

                <h4 style={{ marginTop: "9px", marginBottom: "5px" }}> {t('eula.section2_2.title')}</h4>
                <p>{t('eula.section2_2.body')}</p>

                <h4 style={{ marginTop: "9px", marginBottom: "5px" }}> {t('eula.section2_3.title')}</h4>
                <p>{t('eula.section2_3.body')}</p>

                <h4 style={{ marginTop: "9px", marginBottom: "5px" }}>{t('eula.section2_4.title')}</h4>
                <p>{t('eula.section2_4.body')}</p>

                <h3 style={{ marginTop: "15px", marginBottom: "8px" }}>{t('eula.section3.title')}</h3>
                <h4 style={{ marginTop: "9px", marginBottom: "5px" }}>{t('eula.section3_1.title')}</h4>
                <p>
                    <Trans
                        ns="eula"
                        i18nKey="eula.section3_1.body"
                        values={{ company }}
                    />
                </p>

                <h4 style={{ marginTop: "9px", marginBottom: "5px" }}>{t('eula.section3_2.title')}</h4>
                <p>{t('eula.section3_2.body')}</p>

                <h4 style={{ marginTop: "9px", marginBottom: "5px" }}>{t('eula.section3_3.title')}</h4>
                <p>{t('eula.section3_3.body')}</p>

                <h4 style={{ marginTop: "9px", marginBottom: "5px" }}>{t('eula.section3_4.title')}</h4>
                <p>{t('eula.section3_4.body', { company })}</p>

                <h3 style={{ marginTop: "15px", marginBottom: "8px" }}>{t('eula.section4.title')}</h3>
                <p>{t('eula.section4.body')}</p>

                <h3 style={{ marginTop: "15px", marginBottom: "8px" }}>{t('eula.section5.title')}</h3>
                <p>{t('eula.section5.body')}</p>

                <h3 style={{ marginTop: "15px", marginBottom: "8px" }}>{t('eula.section6.title')}</h3>
                <p>{t('eula.section6.body', { company })}</p>

                <h3 style={{ marginTop: "15px", marginBottom: "8px" }}>{t('eula.section7.title')}</h3>
                <p>{t('eula.section7.body')}</p>

                <h3 style={{ marginTop: "15px", marginBottom: "8px" }}>{t('eula.section8.title')}</h3>
                <p>{t('eula.section8.body')}</p>

                <h3 style={{ marginTop: "15px", marginBottom: "8px" }}>{t('eula.section9.title')}</h3>
                <p>
                    <Trans
                        ns="eula"
                        i18nKey="eula.section9.body"
                        values={{ infoEmail }}
                        components={[<></>, <a href={`mailto:${infoEmail}`} key="infoEmail" />]}
                    />
                </p>

            </DialogContent>

            <DialogActions>
                <SoftButton variant="outlined" color="dark" onClick={handleDecline}>
                    {t('buttons.dialogActions.decline', { ns: 'common' })}
                </SoftButton>
                <SoftButton variant="gradient" color="primary" onClick={handleAccept}
                            sx={{ml: 1, mr:  (direction === 'rtl' ? 1 : 0),
                            }}>
                    {t('buttons.dialogActions.accept', { ns: 'common' })}
                </SoftButton>
            </DialogActions>

        </Dialog>

    );
}

EulaAgreementDialog.propTypes = {
    open: PropTypes.bool,
    handleAccept: PropTypes.func,
    handleDecline: PropTypes.func
}
export default EulaAgreementDialog;